import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { withTranslation } from 'react-i18next';

const COLORS = ['#00C49F', '#F44336', '#FF9800', '#9E9E9E', '#2196F3', '#4CAF50', '#FF5722'];

class SimplePieChart extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      Compliance: PropTypes.number,
      Non_Compliance: PropTypes.number,
      Partially: PropTypes.number,
      Not_Started: PropTypes.number,
      In_Progress: PropTypes.number,
      Done: PropTypes.number,
      Overdue: PropTypes.number,
    })).isRequired,
  };

  renderCustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      return (
        <div style={{
          backgroundColor: '#fff',
          border: '1px solid #ddd',
          borderRadius: '4px',
          padding: '10px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        }}>
          <p style={{ margin: 0, fontWeight: 'bold', color: '#000' }}>
            {`${data.name}: ${data.value}`}
          </p>
        </div>
      );
    }
    return null;
  };

  render() {
    const { data } = this.props;
    //console.log(data);
    const chartData = [
      { name: 'Compliance', value: data[0]?.Compliance || 0 },
      { name: 'Non Compliance', value: data[0]?.Non_Compliance || 0 },
      { name: 'Partially', value: data[0]?.Partially || 0 },
      { name: 'Not Started', value: data[0]?.Not_Started || 0 },
      { name: 'In Progress', value: data[0]?.In_Progress || 0 },
      { name: 'Done', value: data[0]?.Done || 0 },
      { name: 'Overdue', value: data[0]?.Overdue || 0 },
    ].filter(item => item.value > 0); // Only show segments with values > 0

    const hasData = chartData.length > 0;

    return (
      <ResponsiveContainer height={300} width="100%">
        {hasData ? (
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={90}
              innerRadius={0}  // Set innerRadius to 0 for a full pie chart
              dataKey="value"
              animationDuration={800}
              animationEasing="ease-out"
            >
              {
                chartData.map((entry, index) => (
                  <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
                ))
              }
            </Pie>
            <Tooltip content={this.renderCustomTooltip} />
            <Legend
              layout="horizontal"
              align="center"
              verticalAlign="bottom"
              iconType="circle"
              wrapperStyle={{
                paddingTop: '20px',
              }}
              formatter={(value, entry) => {
                const dataItem = chartData.find(item => item.name === value);
                return `${value}: ${dataItem ? dataItem.value : 0}`;
              }}
            />
          </PieChart>
        ) : (
          <div style={{
            height: 300,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            color: '#888'
          }}>
            No Data
          </div>
        )}
      </ResponsiveContainer>
    );
  }
}

export default SimplePieChart;
